/**
 * Window event names the auth state machine communicates over. Dependency-free on purpose —
 * both a plain module (axios-handler.ts) and a client component (SessionHydrator) import these.
 */

/** Profile changed (login, profile edit) — re-read the session to learn the new identity. */
export const USER_DATA_UPDATED_EVENT = 'userDataUpdated';

/** Logged out — the answer is already known, so write it rather than spend a round trip. */
export const USER_LOGGED_OUT_EVENT = 'userLoggedOut';

/**
 * "Something failed in a way that MIGHT mean the session is gone — go ask." Deliberately not
 * a verdict: only GET /v1/auth/session decides, keeping one authority for auth state instead
 * of each failing call guessing.
 */
export const SESSION_SUSPECT_EVENT = 'sessionSuspect';
